<template>
  <div class="home relevant">
    <div class="home-top">
      <img class="home-top-icon" v-if="ishome" src="../../static/img/collection.png" alt="">
      <span class="home-top-title">{{topTitle}}</span>
      <div class="right-sort" @click="changeSort">
        公布时间<img src="" alt="">
      </div>
    </div>
    <div class="data-item" v-for="(item,index) in dataArr" :key="index">
      <div class="item-title" @click="goDetailed(item.id)">{{item.title}}</div>
      <p class="item-abstract">{{item.abstract}}</p>
      <div class="info-item" v-for="(item1,index1) in arrInfo" :key="index1">
        <span class="info-item-title">{{item1[0]}}：</span>
        <span class="info-item-content">{{item[item1[1]]}}</span>
      </div>
      <div class="item-btns">
        <div class="btn-item" @click="collection(item.id,item.collection)">
          <div v-if="item.collection == 2">
            <img src="../../static/img/collection-k.png" alt="">收藏
          </div>
          <div v-else>
            <img src="../../static/img/collection-s.png" alt="">取消收藏
          </div>
        </div>
        <div class="btn-item" @click="download">
          <img src="../../static/img/download.png" alt="">
          下载
        </div>
        <div class="btn-item" @click="toSomewhere">
          <img src="../../static/img/file.png" alt="">
          相关文档
        </div>
      </div>  
    </div>
    <el-pagination
      class="right-pagination"
      background
      layout="prev, pager, next"
      :page-size="dataP.pageSize"
      :total="total"
      :current-page.sync="currentPage"
      @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</template>

<script>
import service from '../service/demoService'
import tool from '../../static/js/public.js'
export default {
  name:'relevant',
  data(){
    return {
      sortType:true,
      topTitle:'相关文档',
      currentPage:1,
      dataP:{
        pageNo:1,
        pageSize:7,
      },
      total:2,
      arrInfo:[
        ['公布时间','time'],
        ['类别','category'],
        ['来源','source'],
      ],
      ishome:true,
      dataArr:[
        {
          id:'1',
          title:'2020年国家科学技术奖获奖名单',
          abstract:'2020年国家科学技术奖通用项目名单，包括国家最高科学技术奖、国家自然科学奖、国家技术发明奖、国家科技进步奖全部等级奖励获奖记录等级获奖记录,2020年国家科学技术奖通用项目名单，包括国家最高科学技术奖、国家自然科学奖、国家技术发明奖、国家科技进步奖全部等级奖励获奖记录国家科技进步奖全部等级奖励。',
          time:'2019-12-23',
          category:'科学研究',
          source:'中华人民共和国科学技术部',
          collection:1,
        },
        {
          title:'2020年国家科学技术奖获奖名单',
          abstract:'2020年国家科学技术奖通用项目名单，包括国家最高科学技术奖、国家自然科学奖、国家技术发明奖、国家科技进步奖全部等级奖励获奖记录等级获奖记录,2020年国家科学技术奖通用项目名单，包括国家最高科学技术奖、国家自然科学奖、国家技术发明奖、国家科技进步奖全部等级奖励获奖记录国家科技进步奖全部等级奖励。',
          time:'2019-12-23',
          category:'科学研究',
          source:'中华人民共和国科学技术部',
          collection:0,
        },
      ],
    }
  },
  watch: {

  },
  methods:{
    changeSort(){ //切换升序降序
      this.sortType = this.sortType == true?false:true;
      let data = tool.copyObj(this.dataArr);
      this.dataArr = [];
      if(this.sortType){
        data.sort((a,b) => {
          return new Date(a.time) - new Date(b.time)
        })
      }else{
        data.sort((a,b) => {
          return  new Date(b.time) - new Date(a.time)
        }) 
      }
      // data.sort(this.sortBy('timeD'),true)
      this.dataArr = data;
      console.log(this.dataArr)
    },
    handleCurrentChange(val){
      this.dataP.pageNo = val;
      this.getData();
    },
    open(str, type) {
      this.$message({
        message: str,
        type: type,
        duration: 800
      });
    },
    getData(){
      let id = this.$route.query.id;
      let data = this.dataP;
      data.id = id;
      service.getrelevant(data).then(res => {
        if(res.state == 0){
          this.dataArr = res.data.list;
          this.total = res.data.total;
        }
      }).catch(err => {
        this.open('系统错误！','warning')
      })
    },
    goDetailed(id){
      this.$router.push({path:'/detailed',query:{id:id}});
    },
    toSomewhere(){  //查看相关文档

    },
    download(){},
    collection(id,type){
      this.dataArr.forEach(item => {
        if(item.id == id){
          item.collection = item.collection == 1 ? 2 : 1 ;
        }
      })
      console.log(id,type);
      let data = {
        id:id,
        type:type == 1?2:1,
      }
      service.collectionbyid(data).then(res => {

      }).catch(err => {
        this.open('系统错误！','warning')
      })
    },
  },
  created(){

  },
  mounted(){
    this.topTitle = this.$route.query.title + '相关文档'
  },
}
</script>

<style lang="less">
  @import '../../static/less/home.less';
  .relevant{
    margin-left: 0px;
  }
</style>


// WEBPACK FOOTER //
// src/components/relevant.vue